import { MapBounds } from "movisat-maps";

export class MarcoGeograficoModel {
    marco: MapBounds;

    constructor(marco: MapBounds) {
        this.marco = marco;
    }
}